import Vue from 'vue'
import Vuex from 'vuex'

import modulesClass from './class'
import appsLogin from './appsLogin'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
  modules: {
    class: modulesClass,
    appsLogin: appsLogin,
  }
})

export default store